export default "__VITE_ASSET__ad73d57e__"